var React = require('react');

function PlaceholderDocument (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#f3f4f6","d":"M640 830H0V0h440l83.59 102.37L640 200v630z","key":0}),React.createElement("path",{"fill":"#e5e7eb","d":"M640 200H440V0l200 200zM120 264h400v64H120zM120 392h400v64H120zM120 520h400v64H120z","key":1})]);
}

PlaceholderDocument.defaultProps = {"viewBox":"0 0 640 830"};

module.exports = PlaceholderDocument;

PlaceholderDocument.default = PlaceholderDocument;
